import React from 'react'
import { Link } from 'react-router-dom'

import ResultSection, { ulClassName, liClassName, linkClassName } from '../ai/ResultSection'
import { useI18N } from '../../../libraries/i18n/hook'
import Translate from '../../../libraries/i18n/Translate'

const BehaviouralResources: React.FC = () => {
  const { t } = useI18N()
  return (
    <ResultSection title={t('interviewer.ai.behavioural.resources.title')}>
      <ul className={ulClassName}>
        <li className={liClassName}>
          <Translate i18nKey='interviewer.ai.behavioural.resources.summary'>
            En esta entrevista se espera que utilices el método STAR para responder las preguntas. Este método ayudar a que tu respuesta sea coherente, lógica y ordenada.
          </Translate>
        </li>
        <li className={liClassName}>
          <Translate i18nKey='interviewer.ai.behavioural.resources.document'>
            En este <Link target='_blank' className={linkClassName} to='/content/documents/105'>documento</Link> podrás encontrar una guía de cómo utilizar el método STAR para responder preguntas de FIT personal.
          </Translate>
        </li>
        <li className={liClassName}>
          <Translate i18nKey='interviewer.ai.behavioural.resources.video'>
            Puedes ver este <Link target='_blank' className={linkClassName} to='/content/videos/82'>video</Link> en el que explicamos cómo preparse una entrevista de FIT.
          </Translate>
        </li>
      </ul>
    </ResultSection>
  )
}

export default BehaviouralResources
